import sObjetos from '@/aplicacao/_servicos/objetos'

function State() {
    this.visivel = true
}

const mutations = {

    resetar(stateParam) {
        sObjetos.preencher(stateParam, new State())
    },

    setVisivel(state, payload) {
        state.visivel = payload
        localStorage.setItem('utilitarios', payload)
    },

}

const actions = {

    resetar({ commit }) {
        commit('resetar')
    },

    abrir({ commit }) {
        commit('setVisivel', true)
    },

    fechar({ commit }) {
        commit('setVisivel', false)
    },

}

const getters = {

}

export default {
    state: new State(),
    mutations,
    actions,
    getters,
}
